import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Divider, Box, Button, Typography, Modal } from "@material-ui/core";
import { AcceptWelcomeMessage } from "../../redux/welcome/actions";

import "./WelcomeMessage.css";

const getModalStyle = () => {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`
    };
};

const WelcomeMessage = () => {
    const { t } = useTranslation();
    const configuration = useSelector(state => state.configuration);
    const welcomeMessageAccepted = useSelector(state => state.welcomeMessageAccepted);
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(true);
    const dispatch = useDispatch();

    const accept = () => {
        setOpen(false);
        dispatch(AcceptWelcomeMessage());
    };
    const close = () => setOpen(false);

    return !configuration.showWelcomeMessage || welcomeMessageAccepted ? null : (
        <Modal aria-labelledby="title" aria-describedby="description" disableBackdropClick open={open} onClose={close}>
            <div style={modalStyle} className="modal-dialog">
                <br />
                <Typography variant="h5" id="title" className="modal-title">
                    {t("Welcome.title")}
                </Typography>
                <br />
                <Divider />
                <br />
                <Box className="welcome" id="description">
                    {configuration.welcomeMessage.map((line, i) => (
                        <Typography key={i}>{line}</Typography>
                    ))}
                </Box>
                <br />
                <Divider />
                <br />
                <Button variant="contained" onClick={accept}>
                    {t("Welcome.accept")}
                </Button>
                <br />
            </div>
        </Modal>
    );
};

export default WelcomeMessage;
